import React, {useEffect, useState} from 'react';
import {Button, TextField} from '@material-ui/core';
import {Field, Form, Formik} from 'formik';
import * as yup from 'yup';
import {seatClassFormStyles} from './seat-classes.styles';
import {toggleQuickPanel} from 'app/main/shared-components/quick-panel/store';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from 'app/store';
import {createSeatClass} from '../store/seat-classes/create-seat-class.slice';
import {updateSeatClass} from '../store/seat-classes/update-seat-class.slice';
import LoadingButton from 'app/main/shared-components/loading-button/LoadingButton';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {SeatClassRequest} from 'app/types/service-types/AircraftTypes';
import LoadingForm from '../../shared-components/loading-form/LoadingForm';

const validationSchema = yup.object({
  name: yup.string().required('Name is required'),
  basePrice: yup.number().min(0, 'Base price must be >= 0').required('Base price is required'),
  priority: yup.number().integer('Priority must be an integer').min(1, 'Priority must be >= 1').required('Priority is required'),
});

const SeatClassForm = () => {
  const classes = seatClassFormStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  let {params} = useRouteMatch();

  const seatClassesState = useSelector((state: AppState) => state.configurations.seatClasses.seatClasses);
  const createState = useSelector((state: AppState) => state.configurations.seatClasses.createSeatClass);
  const updateState = useSelector((state: AppState) => state.configurations.seatClasses.updateSeatClass);

  const [loading, setLoading] = useState(true);
  const [singleSeatClass, setSingleSeatClass] = useState<SeatClassRequest>({
    name: '',
    basePrice: 0,
    priority: 1,
  });
  const [componentTitle, setComponentTitle] = useState('Register');

  useEffect(() => {
    const {seatClasses} = seatClassesState;
    if (params) {
      // @ts-ignore
      const found = seatClasses.find((sc: any) => sc.id === params.id);
      if (found) {
        setComponentTitle('Update');
        setSingleSeatClass({
          name: found.name,
          basePrice: found.basePrice,
          priority: found.priority,
        });
      }
      setLoading(false);
    } else setLoading(false);
  }, []);

  if (loading) return <LoadingForm/>;

  const onSubmitFormRequest = (data: SeatClassRequest) => {
    const {seatClasses} = seatClassesState;
    if (params) {
      // @ts-ignore
      const found = seatClasses.find((sc: any) => sc.id === params.id);
      if (found) {
        const id = found.id ? found.id : '';
        dispatch(updateSeatClass({
          id,
          body: data,
          onSuccess: () => dispatch(toggleQuickPanel())
        }));
      } else {
        dispatch(createSeatClass({body: data}));
      }
    }
  }

  return (
    <div className={classes.formWrapper}>
      <div className={classes.formHeader}>
        <h1 style={{color: '#0D3B66'}}>{componentTitle} Seat Class:</h1>
      </div>
      <Formik
        validateOnChange={true}
        validationSchema={validationSchema}
        initialValues={singleSeatClass}
        onSubmit={onSubmitFormRequest}
      >
        {({errors, touched}) => (
          <Form>
            <div className={classes.row}>
              <Field
                variant='outlined'
                name='name'
                label='Name'
                as={TextField}
                required
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />
            </div>
            <div className={classes.row}>
              <Field
                variant='outlined'
                name='basePrice'
                label='Base Price'
                type='number'
                as={TextField}
                required
                error={touched.basePrice && Boolean(errors.basePrice)}
                helperText={touched.basePrice && errors.basePrice}
              />
            </div>
            <div className={classes.row}>
              <Field
                variant='outlined'
                name='priority'
                label='Priority'
                type='number'
                as={TextField}
                required
                error={touched.priority && Boolean(errors.priority)}
                helperText={touched.priority && errors.priority}
              />
            </div>
            <div className={classes.row}>
              <LoadingButton
                type='submit'
                btnTitle='Submit'
                isLoading={createState.loading || updateState.loading}
              />
              <Button onClick={() => {
                dispatch(toggleQuickPanel());
                history.replace('/configurations/seat-classes');
              }}>
                Close
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SeatClassForm;
